import { MedicalInformationRequestFormComponent } from './components/forms/medical-information-request-form/medical-information-request-form.component';
import { QuizComponent } from './components/quiz/quiz.component';
import { RedirectToExternalLinkModalComponent } from './components/redirect-to-external-link-modal/redirect-to-external-link-modal.component';

export const DYNAMIC_COMPONENTS = {
  MedicalInformationRequestFormComponent: MedicalInformationRequestFormComponent,
  QuizComponent: QuizComponent,
  RedirectToExternalLinkModalComponent: RedirectToExternalLinkModalComponent,
};
